import {
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY,
  PUBLIC_SWS_ENV,
} from '@/constants/env';

import { useAlgoliaSearch } from '../useAlgoliaSearch';

export const useSearch = (query: string, keepPrevData?: boolean) =>
  useAlgoliaSearch({
    algoliaAppId: ALGOLIA_APP_ID,
    algoliaApiKey: ALGOLIA_API_KEY,
    index:
      PUBLIC_SWS_ENV === 'dev' || PUBLIC_SWS_ENV === 'local'
        ? 'companies-dev'
        : 'companies',
    query,
    keepPrevData,
  });
